import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { BaseResultsView } from "./BaseResultsView";

export class GaleResultsView extends BaseResultsView {
  constructor(options) {
    super($.extend(true, {}, options));
    this.resources;
    this.databaseName = "gale";
  }
  loadResults(event, onChangeViewEvent) {
    var _this = this;
    this.resources = event.data.resources;

    if (event.success) {
      TemplateEngine.fetch(
        "tmpl/results/thirdParty/galeResults.html",
        $("#" + _this.resultsId),
        _this.resources,
        function () {
          {
            _this.addEvents();
          }
        },
        TemplateEngine.method.overwrite
      );
    } else {
      $("#" + this.resultsId).empty();
    }
  }
  addEvents() {
    // TODO this is overriding the base class addEvents. Test that this is intentional
    this.addEventHandler($("#" + this.databaseName + "_resultsList"), "click", ".showMore, .showLess", (event) => {
      var dataIndex = $(event.currentTarget).data("index"),
      currentResult = $("#result_resource_" + dataIndex);

      $(event.currentTarget).hide();
      if ($(event.currentTarget).hasClass("showMore")) {
        currentResult.find(".showLess").show();
        currentResult.find(".extraSummary span").show();
      } else {
        currentResult.find(".showMore").show();
        currentResult.find(".extraSummary span").hide();
      }
    });

  }
}
